export default __webpack_public_path__ + "static/media/termo-consentimento-programa-sopro-GSK.2011b068.pdf";